import { Avatar, Box, Chip, Grid, Paper, Stack, Tooltip, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const TrayItem = ({ items, title="", subtitle="", gradients = null, showicon = true }) => {
    const navigate = useNavigate();
    const MotionPaper = motion.create(Paper);
    if (gradients === null) {
        gradients = [
            ["#5B86E5", "#36D1DC"],
            ["#8E2DE2", "#4A00E0"],
            ["#00C9A7", "#92FE9D"],
            ["#FC5C7D", "#6A82FB"],
            ["#FF9966", "#FF5E62"],
            ["#4FACFE", "#00F2FE"],
            ["#43CEA2", "#185A9D"],
            ["#F7971E", "#FFD200"],
        ];
    }

    const container = { hidden: {}, show: { transition: { staggerChildren: 0.06, }, }, };
    const item = { hidden: { opacity: 0, y: 25, }, show: { opacity: 1, y: 0, transition: { duration: 0.45, }, }, };

    if (items === null) return (<></>);
    return (
        <Box sx={{ p: { xs: 1, md: 3 }, }} >
            {!!title || !!subtitle ?
                <Paper elevation={0} sx={{ mb: 3, borderRadius: 5, overflow: "hidden", background: "linear-gradient(135deg, #2563eb 0%, #06b6d4 50%, #3b82f6 100%)", color: "#fff", p: { xs: 2, md: 4 }, }} >
                    <Stack direction={{ xs: "column", md: "row" }} sx={{ justifyContent: "space-between", spacing: 2, alignItems: { xs: "flex-start", md: "center" } }} >
                        <Box>
                            <Typography variant="h4" sx={{ mb: 1, fontWeight: 700 }} >{title}</Typography>
                            <Typography sx={{ opacity: 0.9, maxWidth: 700, }} >{subtitle}</Typography>
                        </Box>
                        <Chip label={`${items.length} Modules`} sx={{ bgcolor: "rgba(255, 255, 255, 0.18)", color: "#fff", fontWeight: 700, px: 2, mt: 2, backdropFilter: "blur(10px)", }} />
                    </Stack>
                </Paper>
                : ""
            }
            <motion.div variants={container} initial="hidden" animate="show">
                <Grid container spacing={2}>
                    {items.map((app, index) => {
                        const gradient = gradients[index % gradients.length];
                        return (
                            <Grid key={index} size={{ xs: 12, sm: 6, md: 4, lg: 3, }} >
                                <MotionPaper variants={item} whileHover={{ y: -6, scale: 1.02, }} whileTap={{ scale: 0.98 }} onClick={() => navigate(app.link)} sx={{ cursor: "pointer", height: "100%", borderRadius: 3, overflow: "hidden", backgroundColor: "background.pallette", backdropFilter: "blur(18px)", border: "1px solid rgba(255, 255, 255, 0.4)", }} >
                                    <Box sx={{ height: 6, background: `linear-gradient(90deg, ${gradient[0]}, ${gradient[1]})`, }} />

                                    <Tooltip title={app.description}>
                                        <Box sx={{ p: 2, display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", }}>
                                            {showicon &&
                                                <Avatar sx={{ width: 58, height: 58, color:"text.primary", backgroundColor: "transparent", mb: 1.2, boxShadow: "0 8px 18px rgba(0, 0, 0, 0.08)", }}>
                                                    {app.image ? <img src={app.image} alt={app.name} loading="lazy" style={{ width: 40, height: 40, objectFit: "contain", }} /> : ""}
                                                </Avatar>
                                            }
                                            <Typography variant="subtitle1" sx={{ lineHeight: 1.2, fontWeight: 700, mb: 0.5 }}>
                                                {app.name}
                                            </Typography>
                                            {app.description &&
                                                <Typography variant="subtitle2" color="textSecondary">
                                                    {app.description || ""}
                                                </Typography>
                                            }
                                            {app.caption &&
                                                <Typography variant="caption" color="textSecondary">
                                                    {app.caption || ""}
                                                </Typography>
                                            }
                                        </Box>
                                    </Tooltip>
                                </MotionPaper>
                            </Grid>
                        );
                    })}
                </Grid>

                {items.length === 0 && (
                    <Paper sx={{ mt: 6, p: 6, borderRadius: 5, textAlign: "center", }} >
                        <Typography variant="h6">No applications found</Typography>
                        <Typography color="textSecondary">Try searching with another keyword.</Typography>
                    </Paper>
                )}
            </motion.div>
        </Box>
    );
}
export default TrayItem;